module.exports = __webpack_public_path__ + "static-portal/img/news12-6.c60d21e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-6.jpg
// module id = LyhW
// module chunks = 4